import { Component, OnInit } from '@angular/core';
import { EmployeeDto } from 'src/app/models/EmployeeDto';
import { EmployeesService } from 'src/app/services/employees.service';

@Component({
  selector: 'app-view-safetyinduction',
  templateUrl: './view-safetyinduction.component.html',
  styleUrls: ['./view-safetyinduction.component.css']
})
export class ViewSafetyinductionComponent implements OnInit {
  Employees: EmployeeDto[] = [];

  constructor(private employeeService: EmployeesService) { }

  ngOnInit(): void {
    this.loadRecords();
  }

  async loadRecords() {

  //  let resEmployees = await this.employeeService.getEmployees().toPromise();
  let resEmployees = await this.employeeService.getEmpsforSafetyUpdate().toPromise();
  
    this.Employees = <EmployeeDto[]>resEmployees.responseData;
  }

}
